<template>
  <transition name="wtf">
    <div class="loadingMask" v-if="isLoading"></div>
  </transition>
</template>

<script>
import {mapState, mapMutations} from 'vuex'

export default {
  computed: {
    ...mapState(['isLoading'])
  },
  methods: {
    ...mapMutations(['showLoading'])
  },
  created () {
    this.$nextTick(_ => {
      this.showLoading(false)
    })
  },
  watch: {
    isLoading (val) {
      if (val) {
        this.$nextTick(_ => {
          this.showLoading(false)
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.loadingMask{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 5;
  background: #000;
}
.wtf-leave-active{
  transition: all 1s;
}

.wtf-leave-to{
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/LoadingMask.vue